<template>
    <!-- <section> -->
    
    <!-- </section> -->
    
    
    <div class="main update_trip_wrp update_trip_wrp_res">
        <div v-if="endTripModal" class="">
            <div class="">
                <div class="">
                    <div id="details" class="overlay waste_type_pop">
                        <div class="overlay_inner">
                            <div class="row form-modal">
                                <vue-form :state="formstate">
                                    <h4 class="text-center"> End Trip Reason</h4>
                                    <div class="col-sm-12" style="padding-top:15px">
    
                                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.endTripReason)">
                                            <!-- <label>End Trip Reason</label> -->
                                            <textarea name="endTripReason" maxlength="200" class="form-control" required v-model="endTripReason" placeholder="End Trip Reason" pattern="[\w\W]{1,200}" />
                                            <!-- <textarea type="text" name="endTripReason" class="form-control" required v-model="endTripReason" placeholder="End Trip Reason" maxlength="200" pattern="^[a-zA-Z][a-zA-Z0-9 @./#+-_]{0,200}"/> -->
                                            <field-messages name="endTripReason" show="$touched || $submitted" class="form-control-feedback validation_msg">
                                                <div slot="required">
                                                   End Trip Reason is a required field
                                                </div>
                                                <div slot="pattern">
                                                    Alphabets/Numbers/Special Characters are allowed.
                                                </div>
                                            </field-messages>
                                        </validate>
                                    </div>
                                </vue-form>
                                <div class="form-actions">
                                    <button type="submit" @click="endTrips" :disabled="!(formstate.$dirty && formstate.$valid)"  v-bind:class="'mr-2 btn gradientbt'">
                                        End Trip
                                    </button>
                                    <!-- <button type="submit" @click="updateCollection" :disabled="!(formstate.$dirty && formstate.$valid)"  v-bind:class="'mr-2 btn gradientbt'">
                                        Update
                                    </button> -->
                                    <button @click="onCloseCDD" v-bind:class="'mr-5  btn btn-default'">
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="d-flex justify-right">
                <div class="addcollecction_wrp"  v-if="details.tripStatus == 'Ongoing'">
                            <button class=" btn gradientbt" @click="endTrip">
                                End Trip
                            </button>
                        </div>
            <div v-if="details.tripStatus == 'Pending' || details.tripStatus == 'Upcoming'" class="c-pointer">
              <a v-on:click.stop="updateTrip()">Update Primary Trip</a>
            </div>
            <div v-if="details.tripStatus == 'Pending' || details.tripStatus == 'Upcoming'" class="c-pointer">
              <a v-if="subCityAdmin" v-on:click.stop="deleteTrip()" style="color:red">Delete Trip</a>
            </div>
          </div>
    
    
            <div class="shedule_date_data_paddi shedule_date_data_new" style="padding: 0px 15px 0px 0px;">
                <div class="shedule_date_data_scroll">
                <div class="shedule_date_data">
                    <div class="shedule_date_inner">
                        <h5>City</h5>
                        <p>{{ details.cityId  ? details.cityId.cityName : "--" }}</p>
                    </div>
                    <div class="shedule_date_inner">
                        <h5>Schedule Date and Time</h5>
                        <p>{{ details.scheduleTiming ? details.scheduleTiming : "--" }}</p>
                    </div>
    
                    <div class="shedule_date_inner">
                        <h5>Trip Start Date and Time</h5>
                        <p>{{ details.tripstartTiming ? details.tripstartTiming : "--" }}</p>
                    </div>
    
                    <div class="shedule_date_inner">
                        <h5>Trip End Date and Time</h5>
                        <p>{{ details.tripEndTiming ? details.tripEndTiming : "--" }}</p>
                    </div>
    
                    <div class="shedule_date_inner">
                        <h5>Trip Start Point</h5>
                        <p>{{details.caId ? details.caId.areaName : "--" }}</p>
                    </div>
    
                    <!-- <div class="shedule_date_inner">
                        <h5>Trip End Point</h5>
                        <p>{{ details.endLoc ? details.endLoc.plantName : "--" }}</p>
                    </div> -->
    
                    <div class="shedule_date_inner">
                        <h5>Driver</h5>
                        <p>{{ details.driverId ? details.driverId.firstName + ' ' + details.driverId.lastName : "--"}}</p>
                    </div>
    
                    <div class="shedule_date_inner">
                        <h5>Helper</h5>
                        <p>{{ details.helperId  ? details.helperId.firstName + ' ' + details.helperId.lastName : "--" }}</p>
                    </div>
                    <div class="shedule_date_inner">
                        <h5>Vehicle</h5>
                        <p>{{details.vehicleId ? details.vehicleId.vNumber : "--"}}</p>
                    </div>
                    <div class="shedule_date_inner">
                        <h5>Total Houses</h5>
                        <p>{{totalCount ? totalCount : "0"}}</p>
                    </div>
                    <div class="shedule_date_inner">
                        <h5>Collected</h5>
                        <p>{{collectedCount ? collectedCount : "0"}}</p>
                    </div>
                    <div class="shedule_date_inner">
                        <h5>Not Collected</h5>
                        <p>{{notCollectedCount ? notCollectedCount : "0"}}</p>
                    </div>
                   
                    <div class="shedule_date_inner">
                        <h5>Total Waste Collected (KG)</h5>
                        <p>{{ details.totalWeight ? details.totalWeight : "0" }}</p>
                    </div>
                    <div class="shedule_date_inner">
                        <h5>Status</h5>
                        <p>{{ details.tripStatus ? details.tripStatus : "--" }}</p>
                    </div>
    
                    <div class="shedule_date_inner">
                        <h5>Odometer Image</h5>
                        <div class="viewPicture" v-on:click.stop="odometerViewImage()" v-bind:style="{cursor: 'pointer'}">
                            <a role="button" v-tooltip.hover title="No Image Available" v-bind:style="{
                    'pointer-events':
                      details.startTripReadingURL == 'null' ||
                      details.startTripReadingURL == null ||
                      details.startTripReadingURL == ''
                        ? 'visible'
                        : 'none',
                  }">
                  <i v-if="details.startTripReadingURL != null && details.startTripReadingURL != 'null' && details.startTripReadingURL != ''" class="fa fa-eye" role="button"></i>
                {{ details.startTripReadingURL == null || details.startTripReadingURL == 'null' || details.startTripReadingURL == "" ? "--" : "" }}
                            <!-- {{details.startTripReadingURL == null || details.startTripReadingURL == "null"  || details.startTripReadingURL == "" ? "--" : "<i class='fa fa-eye' role='button'></i>"}} -->
                        </a>
                           
                            <!-- <a role="button" v-bind:style="(details.startTripReadingURL == 'null' || details.startTripReadingURL == null) ? 'pointer-events: none;' :'pointer-events: visible;' " v-on:click.stop="odometerViewImage()">View</a> -->
                       
                            <!-- <a class="viewPicture" role="button" v-on:click.stop="odometerViewImage()">View</a> -->
                        </div>
    
                    </div>
                    <div class="shedule_date_inner" >
                        <h5>Selfies</h5>
                        <div class="viewPicture" v-on:click.stop="selfiesViewImage()" v-bind:style="{cursor: 'pointer'}">
                            <a role="button" v-tooltip.hover title="No Image Available" v-bind:style="{
                    'pointer-events':
                    details.driverImageUrl == 'null' ||
                      details.driverImageUrl == null ||
                      details.driverImageUrl == ''
                        ? 'visible'
                        : 'none',
                  }">
                            <i v-if="details.driverImageUrl !== null && details.driverImageUrl !== 'null' && details.driverImageUrl !== ''" class="fa fa-eye" role="button"></i>
                            {{details.driverImageUrl == null || details.driverImageUrl == "null"  || details.driverImageUrl == "" ? "--" : ""}}
                        </a>
                            <!-- <a role="button" v-bind:style="(details.driverImageUrl == 'null' || details.driverImageUrl == null) ? 'pointer-events: none;' :'pointer-events: visible;' " v-on:click.stop="selfiesViewImage()">View</a> -->
                       
                            <!-- <a class="viewPicture" role="button" v-on:click.stop="selfiesViewImage()">View</a> -->
                        </div>
    
                    </div>
    
                    <div class="shedule_date_inner">
                        <h5>Odometer Start Reading (KM)</h5>
                        <p>{{ details.startTripReading ? details.startTripReading : "0" }}</p>
                    </div>
                    <div class="shedule_date_inner">
                        <h5>Odometer End Reading (KM)</h5>
                        <p>{{ details.endTripReading ? details.endTripReading : "0" }}</p>
                    </div>
                    <div v-if="details.routeFileUri" class="area_inner">
                        <button role="button" class="view-houses" v-on:click="openRoutePopup">View Route</button>
                    </div>
                    <div v-if="details.reason" class="shedule_date_inner">
                        <h5>Trip End Reason</h5>
                        <a class="viewPicture c-pointer" v-on:click.stop="isReason = true" target="_blank">
                            <i class='fa fa-eye' role='button'></i>
                        </a>
                    </div> 
                    <div v-if="isImg" class="">
                        <div class="overlay waste_type_pop">
                            <div class="overlay_inner">
                                <div class="row form-modal">
                                    
                                    <h4 class="text-center">
                                        {{imgHeader}}
                                    </h4>
                                    <div class="img-wrapper">
                                        <div v-if="odometerImageUrl">
                                            <img :src="odometerImageUrl" class="odometer-img">
                                        </div>
                                        <div v-if="!odometerImageUrl">
                                            No Image Found
                                        </div>
    
                                    </div>
                                    <div class="form-actions">
                                        <button v-on:click.stop="isImg = false" v-bind:class="'mr-5  btn btn-default'">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <div v-if="isReason" class="">
                        <div class="overlay waste_type_pop">
                            <div class="overlay_inner">
                                <div class="row form-modal">
                                    <h4 class="text-center">
                                        Trip End Reason
                                    </h4>
                                    <h5 class="reasonText">
                                        {{details.reason}}
                                    </h5>
                                    <div class="form-actions">
                                        <button v-on:click.stop="isReason = false" v-bind:class="'mr-5  btn btn-default'">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
    
                <div v-if="isMapActive" class="">
                    <div class="location">
                            <div id="details" class="overlay waste_type_pop">
                                <div class="overlay_inner">
                                    <div class="row form-modal">
                                        <div class="d-flex justify-right">
                                            <button @click="onCloseMap" v-bind:class="'mr-5  btn btn-default close-button'">
                                            X
                                        </button>
                                        </div>
                                        <div v-if="houseLocation" class="map-show">
                                            <multiLocation/>
                                        </div>
                                        <div v-if="!houseLocation" class="text-center">
                                            No records Found
                                        </div>
                                        <div class="d-flex justify-right">
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
                <div v-if="isKmlShow" class="">
                    <div class="location">
                            <div id="details" class="overlay waste_type_pop">
                                <div class="overlay_inner">
                                    <div class="row form-modal">
                                        <div class="d-flex justify-right">
                                        <button @click="onCloseMap" v-bind:class="'mr-5 btn btn-default close-button'">
                                            X
                                        </button>
                                        </div>
                                        <div v-if="isKmlShow" class="map-show">
                                            <kmlView/>
                                        </div>
                                        <div class="d-flex justify-right">
                                        
                                    </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
                <div v-if="isMultipleLine" class="">
                <div class="">
                    <div class="">
                        <div id="details" class="overlay waste_type_pop">
                            <div class="overlay_inner">
                                <div class="row form-modal">
                                    <vue-form :state="multipleFormstate">
                                        <h4 class="text-center">Mark Houses Collected for {{collectionDivisonName}}</h4>
                                            <div class="col-sm-12 scroll_pop" style="padding-top: 15px">
                                            <div class="col-sm-12">
                                                <validate auto-label class="form-group required-field"
                                                    :class="fieldClassName(multipleFormstate._id)">
                                                    <label>Lines</label>
                                                    <multiselect track-by="_id" label="value" @input="checkLine()" v-model="multipleLine._id" :options="multiplineData" multiple name="multiplineData" required></multiselect>                                                
                                                </validate>
                                                <field-messages name="multiLine" show="$touched || $submitted" class="form-control-feedback">
                                                    <div slot="required">This is a required field</div>
                                                </field-messages>
                                            </div>
                                            <div class="col-sm-12">
                                                <validate auto-label class="form-group required-field"
                                                    :class="fieldClassName(multipleFormstate.startDate)">
                                                    <label>Collection Date and Time</label>
                                                    <datetime v-if="!this.details.endTime" required id="startDate" type="datetime" @input="checkDate()" :min-datetime="new Date(this.details.startTime).toISOString()" v-model="multipleLine.startDate" lang="en" name="startDate" input-class="form-control" class="theme-wm" placeholder="Collection Date and Time"></datetime>
                                                    <datetime v-if="this.details.endTime" required id="startDate" type="datetime" @input="checkDate()" :min-datetime="new Date(this.details.startTime).toISOString()" :max-datetime="new Date(this.details.endTime).toISOString()" v-model="multipleLine.startDate" lang="en" name="startDate" input-class="form-control" class="theme-wm" placeholder="Collection Date and Time"></datetime>
                                                    <field-messages name="startDate" show="$touched || $submitted" class="form-control-feedback">
                                                        <div slot="required">This is required field</div>
                                                    </field-messages>
                                                </validate>
                                            </div>
                                        </div>
                                    </vue-form>
                                    <div class="form-actions">
                                        <button class="mr-2 btn gradientbt" type="submit" @click="markLines"
                                        :disabled="!(isLineData && isDateData)">
                                            Done
                                        </button>
                                        <button class="mr-5 btn btn-default" type="button" @click="onModalClose">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
                <div class="collection_division_details_ssec collection_division_details_ssec_res">
                    <h3>Collection Division Details</h3>
                    <v-server-table ref="collectionDetailsTable" url :limit="5" :columns="columns" :options="options" @loaded="onLoaded">
                        <template slot="beforeBody">
                            <tr v-if="loading" class="VueTables__no-results">
                                <td class="text-center" colspan="9">
                                    <pulse-loader></pulse-loader>
                                </td>
                            </tr>
                        </template>
    
                        <template slot="action" slot-scope="props">
                            <div class="d-flex">
                                <div class="pointer">
                                <a class="fa fa-eye" role="button" v-on:click.stop="action(props.row)"></a>
                            </div>
                            <div class="pointer ml-20">
                                <a class="fa fa-home" role="button" v-on:click.stop="viewHouseLocation(props.row._id)"></a>
                            </div>
                            <div class="pointer ml-20" v-if="(props.row.NotCollected !== 0 )" >                         
                                <a v-if="details.tripStatus === 'Ongoing' || details.tripStatus === 'Complete'" class="fa fa-check-square" role="button" v-on:click.stop="gotoMultipleLinePopUp(props.row._id)"></a>
                            </div>
                            <div class="pointer ml-20 disableEdit" v-if="(props.row.NotCollected === 0 )" >                         
                                <a v-if="details.tripStatus === 'Ongoing' || details.tripStatus === 'Complete'" class="fa fa-check-square" role="button" v-on:click.stop="gotoMultipleLinePopUp(props.row._id)"></a>
                            </div>
                            </div>
                        </template>
                    </v-server-table>
                    <div class="">
                        <vue-easy-lightbox  :visible="visible" :imgs="imgs" :index="index" @hide="handleHide"></vue-easy-lightbox>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </template>
    <script>
    import VueEasyLightbox from 'vue-easy-lightbox'
    import {
        log
    } from "console";
    import moment from "moment";
    import Datepicker from "vuejs-datepicker";
    import {
        eventBus,
        formService,
        primarytripService
    } from "../../../services";
    import dateFormatter from "../../utilities/dateFormate";
    import swal from "sweetalert2";
    import multiLocation from "../gmapLocation/multiLocation";
    import kmlView from "../gmapLocation/kmlView";
    
    export default {
        name: "viewPrimaryTrip",
        components: {
            Datepicker,
            VueEasyLightbox,
            multiLocation,
            kmlView
        },
    
        data() {
            return {
                endTripReason: {},
                formstate: {},
                multiplineData: [],
                multipleFormstate: {},
                adminCheck: '',
                multipleLine: {},
                isLineData: false,
                isDateData: false,
                endTripModal: false,
                isKmlShow: false,
                imgs: '',
                subCityAdmin:true,
                visible: false,
                isMultipleLine: false,
                index: 0,
                loading: false,
                flash: false,
                flashType: null,
                details: {},
                _id: "",
                parameters: {},
                routeFileUri: '',
                collectionDetailsTable: null,
                isReason: false,
                collectionDivisonName: '',
                collectedCount: null,
                notCollectedCount: null,
                totalCount: null,
                isImg: false,
                isMapActive: false,
                houseLocation: false,
                imgHeader: "",
                odometerImageUrl: "",
                columns: ["cdName", "totalHouse", "collected", "NotCollected", "collectionStatus", "action"],
                options: {
                    highlightMatches: true,
                    headings: {
                        cdName: "Collection Division",
                        totalHouse: "Total Houses",
                        collected: "Collected",
                        NotCollected: "Not Collected",
                        collectionStatus: "Collection Status",
                        action: "Action",
                    },
                    sortable: [
                        "cdName",
                        "totalHouse",
                        "collected",
                        "notCollected",
                        "collectionStatus",
                    ],
    
                    requestFunction: (request) => {
                        this.parameters.page = request.page;
                        this.parameters.limit = request.limit;
                        this.parameters.id = this.$route.params._id;
    
                        if (request.orderBy) {
                            this.parameters.sortBy = request.orderBy
    
                            if (request.ascending == 1) {
                                this.parameters.sortOrder = "asc";
                            } else {
                                this.parameters.sortOrder = "dsc";
                            }
                        }
    
                        if (request.query != "") {
                            this.parameters.searchString = request.query;
                        }
    
                        return primarytripService.getcdList(this.parameters)
                            .catch(error => {
                                console.error('transferredFrom.requestFunction-error:', error);
                                this.$snotify.error('Get wasteTransferredFrom', 'Error!');
                            });
                    },
                    responseAdapter: (response) => {
                        this.loading = false;
                        let dataResp = [];
                        let collectedList = []
                        let notCollectedList = []
                        let totalList = []
                        response.data.response.forEach((element) => {
                            let finalData = element;
                            this.collectionDivisonName = element.cdName;
                            finalData["statusColor"] = element.collectionStatus == 'Collected' ? '#0f6940' : "#f0b548";
                            finalData["collectionStatus"] = element.totalHouse == 0 ? 'N/A' : element.collectionStatus;
                            collectedList.push(element.collected)
                            notCollectedList.push(element.NotCollected)
                            totalList.push(element.totalHouse)
                            dataResp.push(finalData);
                        });
                        this.collectedCount = collectedList.reduce((a, b) => a + b, 0);
                        this.notCollectedCount = notCollectedList.reduce((a, b) => a + b, 0);
                        this.totalCount = totalList.reduce((a, b) => a + b, 0);
                        return {
                            data: dataResp,
                            count: response.data.totalCount || dataResp.length,
                        };
                    },
                },
                perPage: 10,
            };
        },
    
        methods: {
            fieldClassName: formService.fieldClassName,
            gotoMultipleLinePopUp(data) {
                this.isMultipleLine = true;
                this.multipleLine._id = '';
                this.isLineData = false;
                this.isDateData = false;
                this.multipleLine.startDate = '';
                let lineInfo = {
                    tripId: this.$route.params._id,
                    cdId: data
                };
                return primarytripService
                .getLineList(lineInfo)
                .then((response) => {
                        this.loading = false;
                        let lineData = [];
                        response.data.response.forEach((element) => {                                        
                            lineData.push({
                                value: element.collectionDivisionAreaNames,
                                _id: element._id,
                            });
                        });
                        this.multiplineData = lineData;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("lineDetails.getLineDetails-error:", error);
                });
            },
            onModalClose() {
                this.isMultipleLine = false;
            },
            markLines(){
                let lineInfo = {};
                lineInfo.cdaIds = this.multipleLine._id;
                lineInfo.cdaIds = this.multipleLine._id.map((el) => el._id);
                lineInfo.dateTime = this.multipleLine.startDate;
                lineInfo.tripId = this.$route.params._id;
                console.log("lineInfo", lineInfo)
                return primarytripService
                .updateLineList(lineInfo)
                .then((response) => {
                    this.isMultipleLine = false;
                    this.$refs.collectionDetailsTable.refresh();              
                    this.$snotify.success("Mark houses collected successfully.");   
                })
                .catch((error) => {
                    this.$snotify.error(error.data.message, "Error!");
                });
            },
            checkLine(){
                if(this.multipleLine._id.length === 0){
                    this.isLineData = false;
                } else {
                    this.isLineData = true;
                }
            },
            checkDate(){
                if(this.multipleLine.startDate && this.multipleLine._id != []){
                    this.isDateData = true;
                }
            },
            openRoutePopup(){
                this.isKmlShow = true;
                this.routeFileUri = this.details.routeFileUri;
                eventBus.$off("routeFileUriPrimary");
                eventBus.$on("routeFileUriPrimary",() => {
                    eventBus.$emit("routeFileUri", this.routeFileUri);
                });
            },
            endTrips(){
                let primaryTrip = {};
                primaryTrip['_id'] = this.$route.params._id,
                    primaryTrip['reason'] = this.endTripReason
    
                return primarytripService
                    .endTrips(primaryTrip)
                    .then((response) => {
                        this.$snotify.success(`Trip has been ended successfully.`);
                        this.endTripModal = false;
                        this.getTripInfo();
                        // Window.location.reload();
                        this.loading = false;
    
                    })
                    // .then((response) => {
                    //   this.loading = false;
                    // //   this.$router.push("/primarytrip");
                    // })
                    .catch((error) => {
                        this.$snotify.error(error.data.message, "Error!");
                        //   this.$snotify.error(`Trip ended failed`);
                    });
    
            },
            endTrip() {
                this.endTripReason = '';
                this.endTripModal = true;
    
            },
            onCloseCDD() {
                this.endTripReason = '';
                this.endTripModal = false;
    
            },
            getTripInfo() {
                return primarytripService
                    .getById(this.$route.params._id)
                    .then((response) => {
                        this.loading = false;
                        this.details = response.data;
                        this._id = this.details._id;
                        let collections = this.details.cdId.map((el) => el.cdName);
                        this.details["cDivision"] = collections.join(", ");
    
                        let scheduledTime = dateFormatter(this.details.scheduleTime);
                        this.details["scheduleTiming"] = scheduledTime;
                        if (this.details.startTime) {
                            let startTime = dateFormatter(this.details.startTime);
                            this.details["tripstartTiming"] = startTime;
                        }
                        if (this.details.endTime) {
                            let endTime = dateFormatter(this.details.endTime);
                            this.details["tripEndTiming"] = endTime;
                        }
                        let tripStatuss = this.details.tripStatus.charAt(0).toUpperCase() + this.details.tripStatus.slice(1);
                        this.details["tripStatus"] = tripStatuss;
                        this.$store.dispatch("setBreadcrumbTitle", this.details.caId.areaName);
                    })
                    .catch((error) => {
                        this.loading = false;
                        console.error("tripDetails.getTripDetails-error:", error);
                    });
            },
    
            updateTrip() {
                this.$router.push({
                    name: "addPrimaryTrip",
                    params: {
                        _id: this._id,
                    },
                });
            },
            deleteTrip() {
                swal({
                    title: "Are you sure you want to delete?",
    
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    customClass: "swal-modal2",
                    width: "400px",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes, delete it!",
                }).then((result) => {
                    if (result.value) {
                        this.onDelete();
                    }
                });
            },
            onDelete() {
                return primarytripService
                    .deleteTrip(this.$route.params._id)
                    .then((response) => {
                        this.$snotify.success(`Trip has been deleted successfully.`);
                    })
                    .then((response) => {
                        this.loading = false;
                        this.$router.push("/primarytrip");
                    })
                    .catch((error) => {
                        this.$snotify.error(`Trip deletion failed`);
                    });
            },
    
            odometerViewImage() {
                if (
                    !(
                        this.details.startTripReadingURL == "null" ||
                        this.details.startTripReadingURL == null ||
                        this.details.startTripReadingURL == ""
                    )
                ) {
                    this.visible = true
                this.imgs = [this.details.startTripReadingURL, this.details.endTripReadingURL]
    
                }
               
            },
            selfiesViewImage() {
                if (
                    !(
                        this.details.driverImageUrl == "null" ||
                        this.details.driverImageUrl == null ||
                        this.details.driverImageUrl == ""
                    )
                ) {
                    this.visible = true
                this.imgs = [this.details.driverImageUrl, this.details.driverMiddleImageUrl, this.details.driverEndImageUrl]
                }
                
    
            },
            onLoaded() {
                this.collectionDetailsTable = this.$refs.collectionDetailsTable;
            },
            handleHide() {
                this.visible = false
            },
            action(data) {
                this.$router.push({
                    name: "houseDetails",
                    params: {
                        _id: data._id,
                        tripId: this.$route.params._id,
                        tripStart: this.details.startTime,
                        tripEnd: this.details.endTime
                    },
                });
            },
            onCloseMap() {
                this.isMapActive = false;
                this.isKmlShow = false;
            },
            viewHouseLocation(id) {
                this.houseLocations(id)
                this.isMapActive = true;
            },
    
            houseLocations(_id) {
                let housesInfo = []
                let params = {}
                params._id = _id;
                params.tripId = this.$route.params._id;
                params.page = 1;
                params.limit = 99999;
                return primarytripService.getcdDetails(params).then((response) => {
                    response.data.response.forEach((element) => {
                        if (element.geoLoc.length > 0) {
                            let house = element;
                            house['lat'] = element.geoLoc[1]
                            house['lng'] = element.geoLoc[0]
                            housesInfo.push(house)
                        }
                    })
                    if (housesInfo.length > 0) {
                        this.houseLocation = true;
                        setTimeout(() => {
                            eventBus.$emit("housesLocation", housesInfo);
                        }, 300)
                    } else {
                        this.houseLocation = false;
                    }
                }).catch(error => {
                    console.error('trip.requestFunction-error:', error);
                    this.$snotify.error('Get Trip', 'Error!');
                });
            }
        },

        mounted(){
            if (this.$store.state.auth.user.role.key === "subCityAdmin") {
            this.subCityAdmin = false
        }
        },
        created() {
            
            const promises = [];
            this.loading = true;
            this.adminCheck = this.$store.state.auth.user.role.key;
            if (this.$route.params && this.$route.params._id && this.$route.params._id != '0') {
                promises.push(this.getTripInfo());
            }
            Promise.all(promises)
                .then(() => {
                    this.loading = false;
                    this.ready = true;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
    };
    </script>
    
    <style>
    .main {
        margin-left: 15px;
    }
    
    table {
        font-family: arial, sans-serif;
        border-collapse: collapse;
        width: 90%;
        margin: 10px;
    }
    
    td,
    th {
        border: 1px solid #dddddd;
        text-align: left;
        padding: 8px;
    }
    
    .Bold {
        font-weight: bold;
    }
    
    .max-widht-80 {
        max-width: 80px;
    }
    
    .update_trip_wrp .c-pointer {
        text-align: right;
        padding-right: 15px;
    }
    
    .update_trip_wrp .c-pointer a {
        color: #0f6940;
        font-weight: 700;
        font-size: 18px;
        padding-top: 10px;
        display: inline-block;
        text-decoration: underline;
    }
    
    .update_trip_wrp table {
        width: 99%;
        margin: 0;
        margin-top: 20px;
    }
    
    .update_trip_wrp .Bold {
        font-weight: bold;
        background: #0f6940;
        color: #fff;
    }
    
    .update_trip_wrp table th,
    .update_trip_wrp table td {
        border: 1px solid #b3b0b0;
        padding: 10px;
    }
    
    .shedule_date_data {
        background: #0f6940;
        padding: 10px;
        display: flex;
        margin-top: 10px;
        color: #fff;
        flex-wrap: wrap;
    }
    
    .shedule_date_inner {
        flex: 0 0 25%;
        margin-bottom: 5px;
        word-wrap: break-word;
        overflow: hidden;
        padding: 0px 5px;
    }
    
    .shedule_date_data_paddi {
        padding-right: 15px;
    }
    
    .shedule_date_inner p {
        font-size: 15px;
        font-weight: 600;
    }
    
    .shedule_date_inner h5 {
        margin-bottom: 5px;
        font-size: 14px;
        color: #0ce595;
    }
    
    .collection_division_details_ssec h3 {
        font-size: 20px;
        font-weight: 700;
    }
    
    .update_trip_wrp {
        height: calc(100vh - 150px);
        overflow: auto;
        overflow-x: hidden;
    }
    
    .update_trip_wrp::-webkit-scrollbar {
        width: 5px;
    }
    
    .update_trip_wrp::-webkit-scrollbar-thumb {
        background: #888;
    }
    
    .viewPicture {
        /* cursor: pointer; */
        color: #ffffff;
        /* text-decoration: underline; */
    }
    
    .viewPicture:hover {
        color: #ffffff;
        /* text-decoration: underline; */
    }
    
    .viewPicture a {
        color: #fff;
    }
    .overlay {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
    }
    
    .reasonText {
        margin: 25px 25px;
        color: black;
    }
    
    .overlay_inner .form-actions {
        padding: 15px 15px;
    }

    .disableEdit a {
        pointer-events: none;
        color: #94bdaa !important;
    }
    
    .overlay_inner .form-modal h4 {
        color: black;
    }
    
    .odometer-img {
        max-width: 45%;
    }
    
    .img-wrapper {
        text-align: center;
        margin: 10px 10px;
    }
    
    .update_trip_wrp_res .c-pointer .fa-eye{
        color: #fff !important
    }
    
    </style>
    


// WEBPACK FOOTER //
// viewPrimaryTrip.vue?de3921d6